import type { SxProps, Theme } from "@mui/material/styles";
export const root: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100dvh",
  bgcolor: "background.default",
};
export const header: SxProps<Theme> = { bgcolor: "background.paper", p: { xs: 1.75, md: 2.25 }, borderBottom: 1, borderColor: "divider", display: "flex", flexDirection: "column", gap: 1.25 };
export const headerRow: SxProps<Theme> = { display: "flex", alignItems: "center", gap: 1.25 };
export const back: SxProps<Theme> = { color: "text.secondary", display: "flex", textDecoration: "none" };
export const grow: SxProps<Theme> = { flex: 1 };
export const title: SxProps<Theme> = { fontSize: ".90625rem", fontWeight: 700 };
export const meta: SxProps<Theme> = { fontSize: ".6875rem", color: "text.secondary" };
export const content: SxProps<Theme> = { flex: 1, overflowY: "auto", p: { xs: 2.25, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.75 };
export const footer: SxProps<Theme> = { p: { xs: 1.5, md: 2.25 }, borderTop: 1, borderColor: "divider", bgcolor: "background.paper", display: "flex", alignItems: "center" };
